import { axios } from "@/utils/request"

let Api = {
  orgDetail: '/org/detail/', // 机构基本信息
  // orgScholarsList: '/org/detail/', // 学者列表
  orgScholarsList: '/org/detail/', // 学者列表
  getOrgPapersAnalysis: '/org/detail/', //获取机构详情-成果分析(论文领域统计)-趋势分析(论文总数与引用数统计)-核心技术(论文关键词统计)
  getCountryChinaAll: '/country/china/all', // 获取国内省市
  getFieldMap: '/field/getFieldMap',

}

// 机构基本信息
export const getOrgDetailApi = (id, params) => {
  return axios.get( Api.orgDetail + id, { params });
};


// 获取机构-学者列表
export const getOrgScholarsListApi = (params) => {
  return axios.get( Api.orgDetail + 'scholars', { params });
};


// 获取机构-基地列表
export const getOrgBasesListApi = (id, params) => {
  return axios.get( Api.orgDetail + id + '/bases', { params });
};

// 获取机构-论文列表
export const getOrgPapersListApi = (id, params) => {
  return axios.get( Api.orgDetail + id + '/papers', { params });
};

// 获取机构-专利列表
export const getOrgPatentsListApi = (id, params) => {
  return axios.get( Api.orgDetail + id + '/patents', { params });
};

// 获取机构-项目列表
export const getOrgProjectsListApi = (id, params) => {
  return axios.get( Api.orgDetail + id + '/projects', { params });
};

// 获取机构-奖项列表
export const getOrgAwardsListApi = (id, params) => {
  return axios.get( Api.orgDetail + id + '/awards', { params });
};

// 获取企业-产业雷达图
export const getOrgIndustryRadarApi = (id) => {
  return axios.get( Api.orgDetail + id + '/industryRadar' );
};

// 机构详情-招生计划 仅国内高校调用
export const getOrgEnrollmentPlanApi = (name,params) => {
  return axios.get( Api.orgDetail + name + '/enrollmentPlan',{params} );
};
export const getOrgPapersAnalysisApi = (id) => {
  return axios.get( Api.getOrgPapersAnalysis+id+'/papersAnalysis');
};
export const getCountryChinaAllApi = (params) => {
  return axios.get(Api.getCountryChinaAll, { params });
};
// 获取领域分级
export const getFieldMapApi = (params) => {
  return axios.get(Api.getFieldMap, { params });
};

